import { useParams } from "react-router-dom";

import PrivateProfile from "../components/PrivateProfile";
import PublicProfile from "../components/PublicProfile.jsx";
import { useGetCurrentUserQuery } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

const Profile = () => {
  const { userId } = useParams();
  const {
    data: currentUser,
    isSuccess: isCurrentUserSuccess,
    isLoading,
  } = useGetCurrentUserQuery();

  if (isLoading) {
    return <BaseSpinner />;
  }

  if (userId && isCurrentUserSuccess) {
    if (currentUser.id.toString() === userId) {
      return <PrivateProfile userId={userId} />;
    } else {
      return <PublicProfile userId={userId} />;
    }
  }
};

export default Profile;
